// src/pages/utils/autocompleteFilter.js

export function normalizeSearchText(value) {
  return String(value ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[.,]/g, " ")
    .trim();
}

/**
 * Cria um filterOptions para Autocomplete com:
 * - pesquisa case-insensitive
 * - pesquisa sem acentos
 * - várias palavras em modo AND
 *
 * getSearchText é opcional.
 *
 * Exemplos:
 *
 * createAutocompleteFilter()
 *
 * createAutocompleteFilter((option) =>
 *   `${option.ref ?? ""} ${option.nome ?? ""}`
 * )
 */
export function createAutocompleteFilter(getSearchText) {
  return (options, state) => {
    const input = normalizeSearchText(state?.inputValue);

    if (!input) return options;

    const termos = input.split(/\s+/).filter(Boolean);

    return options.filter((option) => {
      const rawText = getSearchText ? getSearchText(option) : state?.getOptionLabel?.(option) ?? "";

      const searchableText = normalizeSearchText(rawText);

      return termos.every((termo) => searchableText.includes(termo));
    });
  };
}

export default createAutocompleteFilter;
